"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapContextParamsToPageEvent = exports.buildViewData = exports.QUEUE_NAME = void 0;
const next_utils_metrics_1 = require("@gerenciatd/next.utils.metrics");
exports.QUEUE_NAME = 'Metrics';
const PAGE_QUEUE = 'Context-Page-Params';
const buildViewData = (data) => {
    let { 'user-type': userType } = data;
    let contextUserRole = '';
    if (userType === 'Gestor') {
        userType = 'Telco';
        contextUserRole = 'gestor';
    }
    return Object.assign(Object.assign({}, data), { 'context-user-role': contextUserRole, 'user-type': userType });
};
exports.buildViewData = buildViewData;
const mapContextParamsToPageEvent = (observerName, callBackNook) => {
    var _a;
    let observer = observerName;
    if (!observer) {
        observer = `observer${Date.now()}`;
    }
    (_a = window.nookInfoExchange) === null || _a === void 0 ? void 0 : _a.registerAsObserver(PAGE_QUEUE, observer, (message) => {
        const object = (0, next_utils_metrics_1.createPageEventObject)(message);
        if (typeof callBackNook === 'function') {
            callBackNook(object);
        }
    }, false);
};
exports.mapContextParamsToPageEvent = mapContextParamsToPageEvent;
//# sourceMappingURL=utils.js.map